import {Pipe, PipeTransform} from '@angular/core';

/**
 * Generated class for the MapPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'filterMap',
})
export class MapPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(map: Map<string, Map<string, Array<number>>>,
            filterKey: string,
            filteredPositionsArray: Array<number>): Array<{ label: string, value: Array<number> }> {
    let filtered = [];
    if (map && filterKey && map.has(filterKey)) {
      const list = map.get(filterKey);
      if (list && list.size > 0) {
        list.forEach((value: Array<number>, key: string) => {
          // If it is undefined, we add anyway (it is the first one)
          if(!filteredPositionsArray){
            filtered.push({label: key, value: value});
          }
          // If it has length > 0 and intersects with the next one, we add values
          else if (filteredPositionsArray.length && this.filterArrayIntersection(value, filteredPositionsArray).length) {
            filtered.push({label: key, value: value});
          }
        });
      }
    }
    return filtered;
  }

  filterArrayIntersection(array1: Array<number>, array2: Array<number>): Array<number> {
    // The filtering function (intersection)
    const filterFunction = (position) => {
      return array2.indexOf(position) > -1;
    };
    return array1.filter(filterFunction);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/map/map.ts